import React, { useCallback, useMemo } from 'react';

import { Box } from '@lyearn/ui';

import FilterGroupLabel from '../FilterGroupLabel';
import { FilterGroup, FilterOption } from '../types';

interface GroupContentProps {
  filterGroup: FilterGroup;
  selectedItemsLength: number;
  addMultiple: (items: FilterOption[]) => void;
  removeMultiple: (items: FilterOption[]) => void;
  isGroupSelectionEnabled?: boolean;
  isSingleSelect?: boolean;
}

function GroupContent({
  filterGroup,
  selectedItemsLength,
  addMultiple,
  removeMultiple,
  isGroupSelectionEnabled,
  isSingleSelect,
}: GroupContentProps) {
  const { options } = filterGroup;
  const isGroupSelected = options.length === selectedItemsLength;

  const indeterminate = useMemo(() => {
    if (isGroupSelected || !selectedItemsLength) {
      return false;
    }
    return true;
  }, [isGroupSelected, selectedItemsLength]);

  const onGroupClick = useCallback(() => {
    if (isGroupSelected) {
      removeMultiple(options);
    } else {
      addMultiple(options);
    }
  }, [isGroupSelected, removeMultiple, addMultiple, options]);

  // group content needs to return an element with some height
  if (!filterGroup.label) {
    return <Box className="pt-2"></Box>;
  }

  return (
    <Box className="mb-6 flex flex-col bg-bg-primary px-8 pt-8 pb-2">
      <FilterGroupLabel
        indeterminate={indeterminate}
        isGroupSelectionEnabled={isGroupSelectionEnabled}
        isSelected={isGroupSelected}
        isSingleSelect={isSingleSelect}
        label={filterGroup.label}
        onClick={onGroupClick}
      />
    </Box>
  );
}

export default React.memo(GroupContent);
